import { forwardRef } from 'react'

import { ArcadeIcon, LockLockedFillIcon } from '@arcade/web/icons/react'

import { isFirstDigitsAmex } from '../../utils/validation'
import { ArcadeHelpTextComponentProps } from '../Arcade/Input/ArcadeHelpText'
import FormattedInput, { BaseFormattedInputProps } from '../Arcade/Input/FormattedInput'

export type CardType = 'debit' | 'credit'

export interface CardNumberInputProps extends BaseFormattedInputProps, ArcadeHelpTextComponentProps {
  /** The type of card (debit or credit) */
  cardType: CardType
}

/**
 * A formatted input for credit/debit card numbers.
 *
 * @example
 * ```tsx
 * <FieldLabel label="Card Number">
 *   <CardNumberInput
 *     type="credit"
 *     value={value}
 *     onChange={setValue}
 *     placeholder="0000 0000 0000 0000"
 *   />
 * </FieldLabel>
 * ```
 */
export const CardNumberInput = forwardRef<HTMLInputElement, CardNumberInputProps>(({ value = '', ...props }, ref) => {
  const isAmex = isFirstDigitsAmex(value)
  const template = isAmex ? '#### ###### #####' : '#### #### #### ####'

  return (
    <FormattedInput
      placeholder={template}
      ref={ref}
      template={template}
      value={value}
      {...props}
      autoComplete="cc-number"
      LeadingIcon={LockLockedFillIcon as ArcadeIcon}
    />
  )
})

export default CardNumberInput
